/**
 * The app's addresses, in one place (navigation handoff §6, Olivia 27 Sep).
 *
 * Every view is a real address, so the browser's Back works across tools and
 * a link can be shared. Old addresses keep working as redirects (see
 * `LegacyRedirects.tsx` and `routes.config.ts`); nothing in `src/` should
 * build one any more.
 */
export const paths = {
  home: "/",
  help: (slug?: string) => (slug ? `/help/${encodeURIComponent(slug)}` : "/help"),
  documents: "/documents",
  documentsShared: "/documents/shared",
  documentsPublishing: "/documents/publishing",
  documentsTag: (tag: string) => `/documents/tag/${encodeURIComponent(tag)}`,
  /** The editor. Short, because it is the link people share. */
  doc: (id: string) => `/d/${id}`,
  tables: "/tables",
  table: (id: string) => `/tables/${id}`,
  references: "/references",
  referencesImports: "/references/imports",
  referencesCollection: (id: string) => `/references/collections/${encodeURIComponent(id)}`,
  equations: "/equations",
  templates: "/templates",
  snippets: "/snippets",
  import: "/import",
  trash: "/trash",
  settings: (section?: string) => (section ? `/settings/${section}` : "/settings"),
} as const;
